import PropTypes from "prop-types"
import React, { useEffect, useCallback, useState } from "react"

import { Modal, ModalBody, ModalHeader, Button } from "reactstrap"
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link, useLocation } from "react-router-dom"
import { ToastContainer, toast } from "react-toastify"
import { withTranslation } from "react-i18next"
import jwtDecode from "jwt-decode"

import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"

import sm1 from "assets/images/services-icon/sm1.svg"
import sm2 from "assets/images/services-icon/sm2.svg"
import sm3 from "assets/images/services-icon/sm3.svg"
import sm4 from "assets/images/services-icon/sm4.svg"
import sm5 from "assets/images/services-icon/sm5.svg"
import sm6 from "assets/images/services-icon/sm6.svg"
import st1 from "assets/images/services-icon/st1.png"
import pen from "assets/images/download.png"
import logolightImg from "../../assets/images/logo-light.png"

import axios from "axios"
import { BASE_URL } from "../../global"
import {
  SESSION_FLEXI_DAYS_MAX,
  SESSION_FLEXI_DAYS_MIN,
} from "../../constants/flexi-session"
import {
  enterAdminMode,
  exitAdminMode,
  getAuthToken,
  getTutorAuthToken,
  getActAsTutorName,
  isAdminMode,
  isTutorAdminEnabled,
  TUTOR_ADMIN_FLAG_CHANGED,
  TUTOR_ADMIN_VIEW_CHANGED,
} from "../../common/auth/tutor-admin-auth"

const SidebarContent = props => {
  const location = useLocation()
  const path = location.pathname

  const [username, setusername] = useState("Admin")
  const [isEditing, setIsEditing] = useState(false)
  const [isSummaryEditing, setIsSummaryEditing] = useState(false)
  const [preferredName, setPreferredName] = useState("")
  const [flexidays, setflexidays] = useState("")
  const [summaryText, setSummaryText] = useState("")

  const [ProfileData, setProfileData] = useState({})

  const authUser = JSON.parse(localStorage.getItem("authUser")) || null

  const [passcode, setPasscode] = useState("")
  const [inputFlexiDaysError, setInputFlexiDaysError] = useState(null)

  const [modal_large, setmodal_large] = useState(false)
  const [selectedOption, setSelectedOption] = useState(0)
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    document.body.classList.contains("vertical-collpsed")
  )
  const [adminMode, setAdminMode] = useState(isAdminMode())
  const [showTutorAdmin, setShowTutorAdmin] = useState(isTutorAdminEnabled())
  const [actAsTutorName, setActAsTutorName] = useState(getActAsTutorName() || "")
  const [adminLoading, setAdminLoading] = useState(false)

  const profileToken = getTutorAuthToken()

  const getmyprofile = useCallback(() => {
    if (profileToken && profileToken !== "" && profileToken !== null) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${profileToken}`
      axios
        .post(BASE_URL + "profile/getmyprofile")
        .then(responseProfile => {
          const profile = responseProfile?.data?.data?.[0] || {}
          setProfileData(profile)
          setflexidays(profile?.tut_flexi_days || "")
          setPasscode(profile?.tut_passcode || "")
          setIsSummaryEditing(false)
        })
        .catch(error => {
          console.log(error?.response?.data?.error)
        })
    }
  }, [profileToken])

  useEffect(() => {
    getmyprofile()
  }, [getmyprofile])

  useEffect(() => {
    setActAsTutorName(getActAsTutorName() || "")
  }, [adminMode, path])

  useEffect(() => {
    const refreshAdminFlag = () => {
      setShowTutorAdmin(isTutorAdminEnabled())
      setAdminMode(isAdminMode())
      setActAsTutorName(getActAsTutorName() || "")
    }

    window.addEventListener(TUTOR_ADMIN_FLAG_CHANGED, refreshAdminFlag)
    window.addEventListener(TUTOR_ADMIN_VIEW_CHANGED, refreshAdminFlag)
    return () => {
      window.removeEventListener(TUTOR_ADMIN_FLAG_CHANGED, refreshAdminFlag)
      window.removeEventListener(TUTOR_ADMIN_VIEW_CHANGED, refreshAdminFlag)
    }
  }, [])

  const handleSwitchToAdmin = async () => {
    try {
      setAdminLoading(true)
      const token = getTutorAuthToken() || getAuthToken()
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
      const response = await axios.post(`${BASE_URL}tutor-admin/switch`)

      if (response?.data?.success) {
        enterAdminMode(response.data.token)
        setAdminMode(true)
        setActAsTutorName("")
        props.router.navigate("/dashboard")
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Unable to switch to admin mode")
    } finally {
      setAdminLoading(false)
    }
  }

  const handleExitAdmin = () => {
    exitAdminMode()
    setAdminMode(false)
    setActAsTutorName("")

    const token = getTutorAuthToken()
    if (token) {
      const jwtdecode = decodeAccessToken(token)
      if (jwtdecode?.success) {
        setusername(jwtdecode.data)
      }
    }

    props.router.navigate("/dashboard")
  }

  function decodeAccessToken(token) {
    try {
      const decoded = jwtDecode(token)
      return { success: true, data: decoded }
    } catch (error) {
      return { success: false, error: error.message }
    }
  }

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      const jwtdecode = decodeAccessToken(obj)

      if (jwtdecode?.success) {
        setusername(jwtdecode.data)
      }
    }
  }, [props.success])

  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent?.childNodes?.[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag
        if (parent3) {
          parent3.classList.add("mm-active") // li
          if (parent3.childNodes?.[0]) {
            parent3.childNodes[0].classList.add("mm-active") //a
          }
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              if (parent5.childNodes?.[0]) {
                parent5.childNodes[0].classList.add("mm-active") // a tag
              }
            }
          }
        }
      }
      return false
    }
    return false
  }, [])

  const removeActivation = items => {
    for (let i = 0; i < items.length; ++i) {
      const item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El = parent?.childNodes?.[1] || null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active")
            if (parent3.childNodes?.[0]) {
              parent3.childNodes[0].classList.remove("mm-active")
            }

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                if (parent5.childNodes?.[0]) {
                  parent5.childNodes[0].classList.remove("mm-active") // a tag
                }
              }
            }
          }
        }
      }
    }
  }

  const activeMenu = useCallback(() => {
    const fullPath = location.pathname
    const ul = document.getElementById("side-menu")
    if (!ul) {
      return
    }

    let matchingMenuItem = null
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (fullPath === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [location.pathname, activateParentDropdown])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [activeMenu])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu, path])

  //profile modal large
  const tog_large = () => {
    setmodal_large(!modal_large)
  }

  const toggleSidebar = () => {
    const body = document.body

    if (window.screen.width <= 992) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }

    setIsSidebarCollapsed(body.classList.contains("vertical-collpsed"))
  }

  const handleEditClick = () => {
    setIsEditing(true)
    setPreferredName(ProfileData.tut_pref_Name || "")
  }

  const handleEditSummaryClick = () => {
    setIsSummaryEditing(true)
    setSummaryText(ProfileData.tut_summary || "")
  }

  const handleInputChange = event => {
    setPreferredName(event.target.value)
  }

  const handleSummaryInputChange = event => {
    setSummaryText(event.target.value)
  }

  const handleInputFlexiChange = event => {
    const _flexiDays = event.target.value
    setflexidays(_flexiDays)

    if (
      _flexiDays === "" ||
      Number(_flexiDays) < SESSION_FLEXI_DAYS_MIN ||
      Number(_flexiDays) > SESSION_FLEXI_DAYS_MAX
    ) {
      setInputFlexiDaysError(
        `The value must be between ${SESSION_FLEXI_DAYS_MIN} and ${SESSION_FLEXI_DAYS_MAX}`
      )
    } else {
      setInputFlexiDaysError("")
    }
  }

  const profileAuthHeader = profileToken
    ? { Authorization: `Bearer ${profileToken}` }
    : {}

  const handleFileUpload = async event => {
    try {
      setIsEditing(false)

      const file = event.target.files?.[0]
      if (!file) {
        return
      }

      const formData = new FormData()
      formData.append("profileImage", file)

      const responseUpdate = await axios.put(
        BASE_URL + `profile/updateMyprofileImage`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            ...profileAuthHeader,
          },
        }
      )

      if (responseUpdate.status === 200) {
        toast.success("Profile image updated successfully", {
          autoClose: 3000,
        })
        getmyprofile()
      } else {
        toast.error("Failed to update profile image", {
          autoClose: 3000,
        })
      }
    } catch (error) {
      toast.error("Error updating profile image", {
        autoClose: 3000,
      })
    }
  }

  const handleSaveClick = async () => {
    try {
      setIsEditing(false)

      const responseUpdate = await axios.put(
        BASE_URL + `profile/updateMyProfile/${ProfileData.pk_tut_key}`,
        { tut_pref_Name: preferredName },
        { headers: profileAuthHeader }
      )

      if (responseUpdate.status === 200) {
        toast.success("Preferred name saved successfully", {
          autoClose: 3000,
        })
        getmyprofile()
      } else {
        toast.error("Failure! Failed to save preferred name", {
          autoClose: 3000,
        })
      }
    } catch (error) {
      toast.error("Failure! Error saving preferred name", {
        autoClose: 3000,
      })
    }
  }

  const handleSaveSummaryClick = async () => {
    try {
      setIsSummaryEditing(false)

      const responseUpdate = await axios.put(
        BASE_URL + `profile/updateMyProfile/${ProfileData.pk_tut_key}`,
        { tut_summary: summaryText },
        { headers: profileAuthHeader }
      )

      if (responseUpdate.status === 200) {
        toast.success("Summary saved successfully", {
          autoClose: 3000,
        })
        getmyprofile()
      } else {
        toast.error("Failure! Failed to save summary", {
          autoClose: 3000,
        })
      }
    } catch (error) {
      toast.error("Failure! Error saving summary", {
        autoClose: 3000,
      })
    }
  }

  //kathir start
  // State to hold the selected value
  useEffect(() => {
    if (ProfileData && ProfileData.tut_clock_is_active !== "") {
      setSelectedOption(parseInt(ProfileData.tut_clock_is_active || 0, 10))
    } else {
      setSelectedOption(0)
    }
  }, [ProfileData])

  // Handler function to update the selected value
  const handleOptionChange = event => {
    handleClockActive(event.target.value)
  }

  const handleClockActive = async data => {
    try {
      setIsEditing(false)
      const responseUpdate = await axios.put(
        BASE_URL + `profile/updateMyProfile/${ProfileData.pk_tut_key}`,
        { tut_clock_is_active: data },
        { headers: profileAuthHeader }
      )
      if (responseUpdate.status === 200) {
        setSelectedOption(data)
        if (parseInt(data, 10) === 1) {
          toast.success("Clock Disabled successfully", {
            autoClose: 3000,
          })
        } else {
          toast.success("Clock Activated successfully", {
            autoClose: 3000,
          })
        }
      } else {
        toast.error("Failure! Failed to save preferred name", {
          autoClose: 3000,
        })
      }
    } catch (error) {
      toast.error("Failure! Error saving preferred name", {
        autoClose: 3000,
      })
    }
  }

  const handleSaveFlexiClick = async () => {
    if (
      Number(flexidays) >= SESSION_FLEXI_DAYS_MIN &&
      Number(flexidays) <= SESSION_FLEXI_DAYS_MAX
    ) {
      try {
        setIsEditing(false)
        const responseUpdate = await axios.put(
          BASE_URL + `profile/updateMyProfile/${ProfileData.pk_tut_key}`,
          { tut_flexi_days: flexidays },
          { headers: profileAuthHeader }
        )

        if (responseUpdate.status === 200) {
          toast.success("Flexi days updated successfully", {
            autoClose: 3000,
          })
          localStorage.setItem("flexiDays", flexidays)
        } else {
          toast.error("Failure! Failed to update flexi days", {
            autoClose: 3000,
          })
        }
      } catch (error) {
        toast.error("Failure! Error saving flexi days", {
          autoClose: 3000,
        })
      }
    } else {
      toast.error(
        `Flexi no of days minimum ${SESSION_FLEXI_DAYS_MIN} day and maximum ${SESSION_FLEXI_DAYS_MAX} days.`,
        {
          autoClose: 3000,
        }
      )
    }
  }

  const generatePasscode = () => {
    const newPasscode = Math.floor(100000 + Math.random() * 900000).toString() // Ensures 6 digits
    handlePasscode(newPasscode)
  }

  const handlePasscode = async data => {
    try {
      setIsEditing(false)
      const responseUpdate = await axios.put(
        BASE_URL + `profile/updateMyProfile/${ProfileData.pk_tut_key}`,
        { tut_passcode: data },
        { headers: profileAuthHeader }
      )

      if (responseUpdate.status === 200) {
        setPasscode(data)
        toast.success("A new passcode has been generated successfully.", {
          autoClose: 3000,
        })
      } else {
        toast.error("Failure! Failed to generate new passcode.", {
          autoClose: 3000,
        })
      }
    } catch (error) {
      toast.error("Failure! Error saving passcode", {
        autoClose: 3000,
      })
    }
  }

  const profileName =
    ProfileData?.tut_fname || ProfileData?.tut_surname
      ? `${ProfileData?.tut_fname || ""} ${
          ProfileData?.tut_surname || ""
        }`.trim()
      : username?.tut_fname || username?.tut_surname
      ? `${username?.tut_fname || ""} ${username?.tut_surname || ""}`.trim()
      : "Tutor"

  return (
    <React.Fragment>
      <ToastContainer autoClose={3000} />

      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          background: "#062b52",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            flexShrink: 0,
            padding: isSidebarCollapsed ? "4px 8px 2px" : "4px 12px 2px",
          }}
        >
          <div
            className={
              isSidebarCollapsed
                ? "d-flex justify-content-center"
                : "d-flex justify-content-end"
            }
            style={{ marginBottom: "2px" }}
          >
            <button
              type="button"
              onClick={toggleSidebar}
              style={{
                border: "none",
                background: "transparent",
                color: "#ffffff",
                padding: 0,
                width: "20px",
                height: "20px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {!isSidebarCollapsed ? (
                <i
                  className="ion ion-ios-arrow-back"
                  style={{ fontSize: "20px" }}
                ></i>
              ) : (
                <i
                  className="ion ion-ios-arrow-forward"
                  style={{ fontSize: "20px" }}
                ></i>
              )}
            </button>
          </div>

          <div
            className="d-flex justify-content-center"
            style={{ marginBottom: "2px" }}
          >
            <Link to="/dashboard">
              <img
                src={logolightImg}
                alt="myGooRoo tutor"
                style={{
                  width: isSidebarCollapsed ? "40px" : "100px",
                  maxWidth: "100%",
                  height: "auto",
                  display: "block",
                }}
              />
            </Link>
          </div>
        </div>

        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            padding: isSidebarCollapsed ? "0 8px 0" : "0 12px 0",
          }}
        >
          <div id="sidebar-menu" style={{ marginTop: 0, paddingTop: 0 }}>
            <ul
              className="metismenu list-unstyled core1"
              id="side-menu"
              style={{ marginTop: 0, paddingTop: 0 }}
            >
              <li>
                <Link to="/dashboard" className="waves-effect">
                  <img width={20} src={sm1} alt="" />
                  <span>{props.t("Home")}</span>
                </Link>
              </li>

              <li>
                <Link to="/session" className="waves-effect">
                  <img width={20} src={sm2} alt="" />
                  <span>{props.t("Sessions")}</span>
                </Link>
              </li>

              <li>
                <Link to="/students" className="waves-effect">
                  <img width={20} src={sm3} alt="" />
                  <span>{props.t("Students")}</span>
                </Link>
              </li>

              <li>
                <Link to="/bmd-reports" className="waves-effect">
                  <img width={20} src={sm3} alt="" />
                  <span>{props.t("Diagnostic Reports")}</span>
                </Link>
              </li>

              <li>
                <Link to="/student-report" className="waves-effect">
                  <img width={20} src={sm3} alt="" />
                  <span>{props.t("Student Report")}</span>
                </Link>
              </li>

              <li>
                <Link to="/myLibrary" className="waves-effect">
                  <img width={20} src={sm4} alt="" />
                  <span>{props.t("My Library")}</span>
                </Link>
              </li>

              <li>
                <Link to="/timesheet" className="waves-effect">
                  <img width={20} src={sm5} alt="" />
                  <span>{props.t("Timesheet")}</span>
                </Link>
              </li>

              <li>
                <Link to="/browse-content" className="waves-effect">
                  <img width={20} src={sm4} alt="" />
                  <span>{props.t("Browse Content")}</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div
          style={{
            flexShrink: 0,
            padding: isSidebarCollapsed ? "4px 8px 0" : "4px 12px 0",
          }}
        >
          {showTutorAdmin ? (
            <div
              style={{
                marginBottom: "4px",
                border: "1px solid rgba(255,255,255,0.25)",
                borderRadius: "4px",
                padding: isSidebarCollapsed ? "6px 4px" : "6px 8px",
              }}
            >
              {!adminMode ? (
                <button
                  type="button"
                  className="btn btn-sm btn-light w-100"
                  onClick={handleSwitchToAdmin}
                  disabled={adminLoading}
                  style={{ fontSize: "11px", padding: "4px 8px" }}
                >
                  {adminLoading ? "Switching..." : "Switch to Admin"}
                </button>
              ) : (
                <>
                  {actAsTutorName && !isSidebarCollapsed ? (
                    <div
                      style={{
                        color: "rgba(255,255,255,0.85)",
                        fontSize: "10px",
                        marginBottom: "4px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      title={actAsTutorName}
                    >
                      Acting as: {actAsTutorName}
                    </div>
                  ) : null}

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light w-100"
                    onClick={handleExitAdmin}
                    disabled={adminLoading}
                    style={{ fontSize: "11px", padding: "4px 8px" }}
                  >
                    Exit Admin
                  </button>
                </>
              )}
            </div>
          ) : null}

          <div>
            <div
              style={{
                border: "1px solid rgba(255,255,255,0.35)",
                borderRadius: "2px",
                padding: isSidebarCollapsed ? "4px 4px" : "4px 8px",
                background: "transparent",
              }}
            >
              <button
                type="button"
                onClick={tog_large}
                style={{
                  border: "none",
                  background: "transparent",
                  width: "100%",
                  padding: 0,
                  textAlign: "left",
                  cursor: "pointer",
                }}
              >
                <div
                  className={
                    isSidebarCollapsed
                      ? "d-flex justify-content-center"
                      : "d-flex align-items-center"
                  }
                >
                  <img
                    width={isSidebarCollapsed ? 26 : 30}
                    height={isSidebarCollapsed ? 26 : 30}
                    src={
                      ProfileData?.tut_profile_pic
                        ? ProfileData.tut_profile_pic
                        : st1
                    }
                    alt=""
                    style={{
                      objectFit: "cover",
                      borderRadius: "999px",
                      marginRight: isSidebarCollapsed ? 0 : "10px",
                    }}
                  />

                  {!isSidebarCollapsed ? (
                    <div style={{ minWidth: 0 }}>
                      <div
                        style={{
                          color: "#ffffff",
                          fontSize: "12px",
                          fontWeight: 700,
                          lineHeight: 1.2,
                          wordBreak: "break-word",
                        }}
                      >
                        {profileName}
                      </div>
                      <div
                        style={{
                          color: "rgba(255,255,255,0.72)",
                          fontSize: "10px",
                          lineHeight: 1.2,
                          marginTop: "1px",
                        }}
                      >
                        Edit profile
                      </div>
                    </div>
                  ) : null}
                </div>
              </button>

              <div
                className={
                  isSidebarCollapsed ? "d-flex justify-content-center" : ""
                }
                style={{ marginTop: "4px" }}
              >
                <Link
                  to="/logout"
                  className="waves-effect cp-pd-0"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "#ffffff",
                    textDecoration: "none",
                    gap: isSidebarCollapsed ? "0" : "8px",
                    fontSize: "11px",
                    fontWeight: 600,
                  }}
                >
                  <img width={20} src={sm6} alt="" />
                  {!isSidebarCollapsed ? (
                    <span>{props.t("Log out")}</span>
                  ) : null}
                </Link>
              </div>
            </div>

            <div style={{ marginTop: "2px" }}>
              <NotificationDropdown
                variant="sidebar"
                compact={isSidebarCollapsed}
              />
            </div>
          </div>
        </div>

        {process.env.REACT_APP_VERSION ? (
          <div
            style={{
              flexShrink: 0,
              padding: "4px 0 6px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <span className="badge tb-danger font-size-10 cp-bdg">
              {process.env.REACT_APP_VERSION}
              {process.env.REACT_APP_GIT_HASH
                ? `(${process.env.REACT_APP_GIT_HASH.substring(0, 7)})`
                : ""}
            </span>
          </div>
        ) : null}
      </div>
      {/* modal */}

      <Modal isOpen={modal_large} toggle={tog_large} size="lg">
        <div className="p-4">
          <ModalHeader className="mt-0" toggle={tog_large}>
            <div>
              <h6 className="profile_header">My Profile</h6>
              <p className="headerTimeline">Last modified February 2024</p>
            </div>
          </ModalHeader>
          <ModalBody style={{ padding: "12px" }}>
            <div className="pr-wrapper d-flex">
              <div className="cl-left me-22">
                <div className="profileSection text-center position-relative">
                  <img
                    width={20}
                    src={
                      ProfileData.tut_profile_pic
                        ? ProfileData.tut_profile_pic
                        : st1
                    }
                    alt=""
                    className="profileSection-img rounded-circle"
                  />
                  <div className="edit-float">
                    <form autoComplete="off">
                      <label htmlFor="file-upload">
                        <input
                          id="file-upload"
                          accept="image/*"
                          multiple
                          type="file"
                          style={{ display: "none" }}
                          onChange={handleFileUpload}
                        />
                        <img src={pen} alt="Upload Profile" />
                      </label>
                    </form>
                  </div>
                </div>
                <div className="Profile_title text-center mt-2 mb-4">
                  Tutor ID: {ProfileData.pk_tut_id}
                </div>

                <div className="d-flex text-center justify-content-between">
                  <div className="Profile_lable me-3">Preferred name</div>
                  <img src={pen} alt="" onClick={handleEditClick} />
                </div>
                <div className="profile_value mb-3">
                  {isEditing ? (
                    <div className="input-section">
                      <input
                        type="text"
                        value={preferredName}
                        onChange={handleInputChange}
                        onBlur={handleSaveClick}
                        className="form-control"
                      />
                    </div>
                  ) : (
                    <div className="profile_valuess mb-3">
                      {ProfileData.tut_pref_Name}{" "}
                    </div>
                  )}
                </div>
                <div className="d-flex text-center justify-content-between">
                  <div className="Profile_lable me-3">Summary</div>
                  <img src={pen} alt="" onClick={handleEditSummaryClick} />
                </div>
                <div className="profile_value mb-3">
                  {isSummaryEditing ? (
                    <div className="input-section">
                      <textarea
                        value={summaryText}
                        onChange={handleSummaryInputChange}
                        onBlur={handleSaveSummaryClick}
                        className="form-control"
                      />
                    </div>
                  ) : (
                    <div className="profile_valuess mb-3">
                      {ProfileData.tut_summary}{" "}
                    </div>
                  )}
                </div>

                <div className="d-flex text-center justify-content-between mt-4">
                  <div className="Profile_lable me-3">Setting</div>
                </div>
                <div className="profile_value mb-3">
                  <div className="profile_detail_title mt-2 ms-2">Clock</div>
                  <div className="input-section mt-2 ms-4">
                    <div className="form-check mt-4">
                      <input
                        type="radio"
                        value={0}
                        className="form-check-input"
                        checked={parseInt(selectedOption, 10) === 0}
                        onChange={handleOptionChange}
                      />
                      <label
                        className="form-check-label mb-0 fw-medium"
                        htmlFor="Active"
                      >
                        Active
                      </label>
                    </div>
                    <div className="form-check mt-4">
                      <input
                        type="radio"
                        value={1}
                        className="form-check-input"
                        checked={parseInt(selectedOption, 10) === 1}
                        onChange={handleOptionChange}
                      />
                      <label
                        className="form-check-label mb-0 fw-medium"
                        htmlFor="Disable"
                      >
                        Inactive
                      </label>
                    </div>
                  </div>
                </div>
                <div className="profile_value mb-3">
                  <div className="profile_detail_title mt-2 ms-2">
                    Flexi days
                  </div>

                  <div className="input-section mt-2 ms-2">
                    <div className="form-check mt-2">
                      <input
                        type="number"
                        value={flexidays ? flexidays : ""}
                        className="form-control"
                        onChange={handleInputFlexiChange}
                        onBlur={handleSaveFlexiClick}
                        min={SESSION_FLEXI_DAYS_MIN}
                        max={SESSION_FLEXI_DAYS_MAX}
                      />
                      {inputFlexiDaysError ? (
                        <p className="cs-txt-danger">{inputFlexiDaysError}</p>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="profile_value mb-3">
                  <div className="profile_detail_title mt-2 ms-2">
                    Generate Passcode
                  </div>
                  <div className="d-flex items-center gap-4 ">
                    <div className="input-section mt-2 ms-2">
                      <div className="form-check mt-2">
                        <input
                          value={passcode}
                          readOnly
                          placeholder="Generated Passcode"
                          className="form-control text-center mb-2"
                        />
                        <div className="text-end">
                          <Button
                            onClick={generatePasscode}
                            color="primary"
                            className="w-100"
                          >
                            Generate
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="vertical-divider"></div>

              <div className="cl-right ms-22">
                <div className="profile-detail-wrap">
                  <div className="st-wrapper">
                    <div className="row">
                      <div className="col-5 Profile_subtitle me-5">
                        <h5 className="font-size-14 fw-700 text-dark mb-10">
                          Account
                        </h5>
                      </div>
                      <div className="col-4"></div>
                      <div className="col-5 Profile_subtitle me-5">
                        Username
                      </div>
                      <div className="col-4">
                        <h5 className="profile_value_acc me-3">
                          {" "}
                          {ProfileData.tut_fname} {ProfileData.tut_surname}
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className="profile_detail_title pd-12">
                    <h5 className="font-size-14 fw-700 text-dark mb-10">
                      Personal Information
                    </h5>

                    <div className="row mt-2">
                      <div className="col-5  me-5 mb-3">
                        <p className="Profile_subtitle">Salutation</p>
                        <p className="profile_info">-</p>
                      </div>

                      <div className="col-4  me-5 mb-3">
                        <p className="Profile_subtitle">First Name</p>
                        <p className="profile_info">{ProfileData.tut_fname}</p>
                      </div>
                      <div className="col-5  me-5">
                        <p className="Profile_subtitle">Last Name</p>
                        <p className="profile_info">
                          {ProfileData.tut_surname}
                        </p>
                      </div>

                      <div className="col-4  me-5">
                        <p className="Profile_subtitle">Birth date</p>
                        <p className="profile_info">{ProfileData.tut_dob}</p>
                      </div>
                    </div>
                  </div>

                  <div className="pd-12">
                    <div className="profile_detail_title">
                      Address Information
                    </div>
                    <div className="col-12 mt-2">
                      <p className="Profile_subtitle">Address</p>
                      <p className="profile_info text-dark mb-3">
                        {ProfileData.tut_address}
                      </p>
                    </div>

                    <div className="row mt-2">
                      <div className="col-5  me-5 mb-3">
                        <p className="Profile_subtitle">Country</p>
                        <p className="profile_info">
                          {ProfileData.tut_country}
                        </p>
                      </div>

                      <div className="col-4  me-5 mb-3">
                        <p className="Profile_subtitle">State</p>
                        <p className="profile_info">{ProfileData.tut_state}</p>
                      </div>
                      <div className="col-5  me-5">
                        <p className="Profile_subtitle">City</p>
                        <p className="profile_info">{ProfileData.tut_city}</p>
                      </div>

                      <div className="col-4  me-5">
                        <p className="Profile_subtitle">Postcode</p>
                        <p className="profile_info">754688</p>
                      </div>
                    </div>
                  </div>

                  <div className="pd-12">
                    <div className="profile_detail_title">
                      Contact Information
                    </div>

                    <div className="row">
                      <div className="col-5 me-5 mb-3 mt-2">
                        <p className="Profile_subtitle">Home Phone</p>
                        <p className="profile_info">
                          {ProfileData.tut_home_phone}
                        </p>
                      </div>

                      <div className="col-4  me-5 mb-3">
                        <p className="Profile_subtitle">Work Phone</p>
                        <p className="profile_info">
                          {ProfileData.tut_work_phone}
                        </p>
                      </div>
                      <div className="col-5  me-4">
                        <p className="Profile_subtitle">Mobile</p>
                        <p className="profile_info">
                          {ProfileData.tut_mobile
                            ? ProfileData.tut_mobile
                            : "-"}
                        </p>
                      </div>

                      <div className="col-4  me-5">
                        <p className="Profile_subtitle">Email</p>
                        <p className="profile_info">
                          {ProfileData.tut_emailid}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="pd-12">
                    <div className="profile_detail_title">About Tutor</div>
                    <div className="col-12  me-5 mt-2">
                      <p className="Profile_subtitle">
                        {ProfileData.tut_notes}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="status-wrapper mt-10">
                  <p className="d-flex align-items-center text-dark">
                    {" "}
                    <span className="cs-txt-danger">
                      <i className="fas fa-exclamation-circle font-size-20 me-2"></i>
                    </span>{" "}
                    Please notify your admin immediately if the information is
                    not accurate.
                  </p>
                </div>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  success: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
